export interface NavLink {
    title: string;
    route: string;
}

export const LINK_ITEMS: NavLink[] = [
    { title: 'About', route: 'about' },
    { title: 'Services', route: 'services' },
    { title: 'Accomplishment', route: 'accomplishment' },
    { title: 'Contact', route: 'contact' },
    { title: 'Career', route: 'career' },
    { title: 'Certifications', route: 'certifications' },
];